<template>
  <div class="wrap">
    <!-- 数据下载 -->
    <div class="data-download" :class="{ pr20: panelShow }">
      <div class="data-download-title">
        <div class="file-list">
          <span></span>
          <div class="file-list-title">{{$t('design.orderDetail.fileList') || "文件列表"}}</div>
        </div>
        <div class="operate-box">
          <xl-checkbox
            v-model="checkAll"
            :indeterminate="isAllIndeterminate"
            @change="handleCheckAll"
          >
            {{
              checkedFilesList.length ? checkedFilesList.length + $t('design.orderDetail.item') || '项' : $t('design.orderDetail.checkAll') || '全选'
            }}
          </xl-checkbox>
          <xl-divider class="" direction="vertical" />
          <xl-button size="small" :disabled="!checkedFilesList.length" @click="handleDownload" :loading="downloading">{{$t('design.download.btn') || '下载'}}</xl-button>
        </div>
      </div>
      <div class="files-box">
        <xl-scrollbar>
          <div
            class="files-list-box"
            v-for="(fileList, index) in filesList"
            :key="fileList.filesType"
          >
            <filesListContainer
              :ref="(el) => (fileListRef[index] = el)"
              :fileList="fileList"
              :checkAll="checkAll"
              :checkedFilesList="checkedFilesList"
              :orderID="orderID"
              :platform="platform"
            ></filesListContainer>
            <!-- <div class="file-type-box">
              <div class="files-list-title">
                <img src="../../../assets/image/file_icon.svg" alt="" />
                <div class="files-type">
                  {{ fileList.filesType }}（{{ fileList.files.length }}）
                </div>
              </div>
              <xl-checkbox
                v-model="checkFilesType"
                :indeterminate="isFilesIndeterminate"
                @change="handleCheckFilesType(fileList.filesType)"
              >
              </xl-checkbox>
            </div>
            <xl-checkbox-group v-model="checkedFiles" @change="handleCheckedFile">
              <div
                class="file-box"
                v-for="file in fileList.files"
                :key="file.fileType"
              >
                <div class="file-line"></div>
                <div class="file-name-box">
                  <div class="file-info">
                    <img src="../../../assets/image/file_icon.svg" alt="" />
                    <div class="file-type">
                      {{ file.fileType }}--<span class="file-name">{{
                        file.filename
                      }}</span>
                    </div>
                  </div>
                  <div class="file-type file-name create-time">
                    {{ file.createOn }}
                  </div>
                </div>
                <xl-checkbox :key="file.id" :label="file.id" :value="file.id">{{  }}
                </xl-checkbox>
              </div>
            </xl-checkbox-group> -->
          </div>
        </xl-scrollbar>
      </div>
    </div>
    <preprint-list class="preprint-list" :class="{ panelShow, [$lang()]: true }" :inline="true"></preprint-list>
  </div>
</template>
<script setup>
import {
  XlScrollbar,
  XlButton,
  XlDivider,
  XlCheckbox,
  XlMessage
} from "@shining3d/ui-components";
import PreprintList from "../../../components/preprintList/preprintList.vue";

import { ref, reactive, computed, watch, onMounted, defineProps, defineExpose, onUnmounted } from "vue";
import _get from 'lodash/get';
import filesListContainer from "./filesList.vue";
import { $getCdnUrl, $convertUTCDateToLocalDate } from '../../../utils/common.js'
import store from '@/store';
import router from '@/router';
import Bus from '../../../utils/bus.js';
import { VueCookieNext } from 'vue-cookie-next';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { $lang } from "@shining3d/common-module/utils/index.js";

// import Api from '../../../api/orderDetail/index.js';
const { $t } = useLang("@shining3d/xl-design-order");
const route = router.currentRoute.value;

import { orderDetail } from '../../../api/orderDetail/index.js';
const props = defineProps({ 
  platform: { // 默认为云平台
    type: String,
    default: 'dental'
  }
})
const Api = orderDetail[props.platform];

const orgID = computed(() => _get( store, 'state.factorySelect.id', ''));
const orderID = computed(() => _get( route, 'params.id', '' ));

const AI_FILE_TYPES = ['ai_design_preview',  'ai_design_exocad', 'ai_design_stl'];

const fileListRef = ref([]);
// 全选
const checkAll = ref(false);
const isAllIndeterminate = ref(false);

// 选择的文件列表
const checkedFilesList = computed(() => {
  const checkedList = [];
  fileListRef.value.forEach((item) => {
    checkedList.push(...item.checkedFiles);
  });
  return checkedList;
});
const allFiles = computed(() => {
  const allList = [];
  filesList.value.forEach((item) => {
    allList.push(...item.files.filter(i => !(item.attachType === 'full_ai_design' && item.status === 'failed')).map((i) => i.id));
  });
  return allList;
});
const handleCheckAll = (val) => {
  // const filesListId = []
  // filesList.forEach((item) => {
  //     filesListId.push(...item.files.map((i) => i.id))
  // })
  checkedFilesList.value = val ? allFiles : [];
  isAllIndeterminate.value = false;
    fileListRef.value.forEach((item) => {
      if( val){
        item.handleCheckFilesType(true);
        item.checkFilesType = true;
      } else {
        item.handleCheckFilesType(false);
        item.checkFilesType = false;
      }
    });
};

// 下载文件url list
const urlList = ref([]);
const allCheckedList = ref([]);
// 下载文件
const downloadFile = (url) => {
  const iframe = document.createElement("iframe");
  iframe.style.display = "none"; // 防止影响页面
  iframe.style.height = 0; // 防止影响页面
  iframe.src = url;
  document.body.appendChild(iframe);
  setTimeout(() => {
    iframe.remove();
  }, 5*60*1000);
};
const downloading = ref(false);
const handleDownload = () => {
  // urlList.value.forEach((url) => {
  //   downloadFile(url);
  // });
  // 获取下载地址
  downloading.value = true;
  let params = {}
  console.log('props.platform', props.platform);
  if(props.platform === 'designerService'|| props.platform === 'dentalxDesign') {
			const fileID = [];
			const transferFileID = []
			allCheckedList.value.forEach(file => {
				if(file.orderID === orderID.value) {
					transferFileID.push(file.id)
				} else {
					fileID.push(file.id)
				}
			});
      params = {
        transferOrderID: orderID.value,
        transferFileID,
        fileID
      }
  } else {
    params = {
      orgID: orgID.value,
      orderID: orderID.value,
      fileID: urlList.value
    }
  }
  Api.getDownLoadURL(params).then( res => {
    if ( res && res.status === 'success' ) {
      const downloadList = res.result || [];
      downloadList.forEach((url) => {
        const downloadUrl = new URL(url);
        if ( url.includes('/ai_') ) {
          downloadUrl.searchParams.append('response-content-type', 'APPLICATION/OCTET-STREAM'); 
        }
        downloadFile(downloadUrl.toString());
      });
    }
    downloading.value = false;
  }).catch(() => {
    downloading.value = false
  });
};
const filesList = ref([]);
watch(
  () => checkedFilesList.value,
  (val) => {
    if (val) {
      urlList.value = [];
      allCheckedList.value = []
      isAllIndeterminate.value =
        val.length > 0 && val.length < allFiles.value.length;
      checkAll.value = val.length === allFiles.value.length;
      // 获取选择文件的url
      filesList.value.forEach((item) => {
        item.files.forEach((file) => {
          if (val.includes(file.id)) {
            urlList.value.push( file.id );
            allCheckedList.value.push(file);
            // urlList.value.push(file.url);
          }
        });
      });
    }
  }
);

const fileTypeMap = {
  lowerJaw: {
    filesType: $t('design.download.orignfile') || '原始文件',
    feIndex: 3,
    fileType: $t('design.download.lowerJawfile') || '下颌文件'
  },
  upperJaw: {
    filesType: $t('design.download.orignfile') || '原始文件',
    feIndex: 3,
    fileType: $t('design.download.upperJawfile') || '上颌文件'
  },
  totalJaw: {
    filesType: $t('design.download.orignfile') || '原始文件',
    feIndex: 3,
    fileType: $t('design.download.totalJawfile') || '咬合文件'
  },
  full_other: {
    filesType: $t('design.download.orignfile') || '原始文件',
    feIndex: 3,
    fileType: $t('design.download.otherfile') || '其他附件'
  },
  quality: {
    filesType: $t('design.download.qualityfile') || '质控文件',
    feIndex: 4,
    fileType: $t('design.download.screenshot') || '截图'
  },
  model: {
    filesType: $t('design.download.finallyfile') || '设计结果文件',
    feIndex: 0,
    fileType: $t('design.download.resultfile') || '结果文件',
    fileTypeKey: 'resultModel'
  },
  project: {
    filesType: $t('design.download.projectfile') || '设计工程文件',
    feIndex: 2,
    fileType: $t('design.download.project.itemfile') || '工程文件'
  },
  // full_ai_design: {
  //   filesType: $t('design.download.aidesign') || 'AI设计文件',
  //   feIndex: 5,
  //   fileType: $t('design.download.aidesign') || 'AI设计文件'
  // },
  ai_design_exocad: {
    filesType: $t('design.download.aidesign') || 'AI设计文件',
    feIndex: 1,
    fileType: $t('design.download.aiDesignProjectFile') || 'AI设计工程文件'
  },
  ai_design_preview: {
    filesType: $t('design.download.aidesign') || 'AI设计文件',
    feIndex: 1,
    fileType: $t('design.download.aiDesignPreview') || 'AI设计截图文件'
  },
  ai_design_stl: {
    filesType: $t('design.download.aidesign') || 'AI设计文件',
    feIndex: 1,
    fileType: $t('design.download.aidesign') || 'AI设计文件',
    fileTypeKey: 'resultModel'
  },
};

// 获取影像文件的配置
const imageFileMap = ref({});
// 获取影像文件配置信息 
const getFileConfig = async () => {
  await Api.fetchImageSetting({
      lang: $lang()
    }).then( res => {
        if ( res && res.status === 'success' ) {
            const list = res.result || [];
            const obj = {};
            list.forEach(item => {
                obj[item.imageUniqueCode] = item;
            });
            imageFileMap.value = obj;
        }
    });
};

const getList = (from = '') => {
  Api.orderDownloadList({
    orgID: orgID.value,
    orderID: orderID.value
  }).then( res => {
    if ( res && res.status === 'success' ) {
      const listMap = {};

      const list = res.result || [];
      list.forEach( item => {
        const url = $getCdnUrl({ bucket: item.bucket, dfsID: item.dfsID });
        const filename = item.attachType === 'full_ply_exocad' ? `${item.fileName}(for exo)` : item.fileName;
        const obj = {
          filename,
          createOn: $convertUTCDateToLocalDate(item.createOn),
          id: item.id,
          orderID: item.orderID,
          url,
          printSupport: item.printSupport,
          hasPrinted: item.hasPrinted,
          hasWaitingPrint: item.hasWaitingPrint
        };

        let type = '';
        if ( ['full_stl', 'full_ply', 'full', 'full_image', 'full_system', 'full_ply_exocad'].includes( item.attachType )) {
          // 原始文件
          type = item.detailType;
          if ( type.includes('totalJaw') ) {
            type = 'totalJaw';
          }
        } else if ( item.attachType === 'full_other') {
          // 原始文件
          type = item.attachType;
        } else if ( AI_FILE_TYPES.includes(item.attachType)) {
          type = item.attachType;
        } else {
          // 质控文件，设计工程文件，设计结果文件
          type = item.classType;
        }
        let { filesType, fileType, feIndex, fileTypeKey } = fileTypeMap[type] || {};

        // 原始文件的 名称需要接口去获取
        if ( ['full_stl', 'full_ply', 'full', 'full_image','full_system', 'full_ply_exocad'].includes( item.attachType )) {
          filesType = $t('design.download.orignfile') || '原始文件';
          feIndex = 3;
          if ( imageFileMap.value[type]?.imageName ) {
            fileType = imageFileMap.value[type].imageName;
          }
          // 扫描岗数据的名称
          if (['commonSystem', 'codingSystem'].includes(type)) {
            // 种植
            fileType = $t('design.case.downloadPlant') || '种植数据库文件'
          } else if ( type === 'implantSystem' ){
            // 植体
            fileType = $t('design.case.downloadImPlant') || '植体数据库文件'
          }
        }

        if (listMap[filesType]) {
          listMap[filesType].files.push({
            ...obj,
            fileType,
            fileTypeKey
          })
        } else {
          listMap[filesType] = {
            filesType,
            feIndex,
            fileTypeKey,
            status: item.status,
            attachType: item.attachType,
            files: [{
              ...obj,
              fileType,
              fileTypeKey
            }]
          }
        }
      });
      Object.keys(listMap).forEach(key=> {
        listMap[key].files = listMap[key].files.sort((a,b)=> a.filename.localeCompare(b.filename));
      })
      let newList = Object.values(listMap).sort((a, b) => a.feIndex - b.feIndex);
      filesList.value = newList;
      console.log( 'filesList.value', filesList.value );
      if ( from === 'refresh' ) {
        XlMessage({
            type: 'success',
            message: $t('design.refreshSuccess') || '刷新成功'
        });
      }
    }
  });
};

const getInfo = async ( from = '') => {
  await getFileConfig();
  getList( from );
}

const refresh = () => {
  getInfo('refresh');
};

onMounted(() => {
  getInfo();
});

const panelShow = ref( false );
Bus.$on( 'preprintPanelVisible', ( flag ) => {
  panelShow.value = flag
});

Bus.$off( 'updatePreprintItem' );
Bus.$on( 'updatePreprintItem', getInfo );

onUnmounted(() => {
  Bus.$off( 'updatePreprintItem' );
})


defineExpose({ refresh });
</script>
<style lang="scss" scoped>
.wrap {
  padding: 13px 16px 16px 16px;
  height: calc(100% - 32px);
  display: flex;
}
.data-download {
  flex: 1;
  height: 100%;
  overflow: hidden;
  .data-download-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    height: 32px;
    .operate-box {
      display: flex;
      align-items: center;
    }
    .file-list {
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #5587ff;
        margin-right: 8px;
      }
    }
    .file-list-title {
      display: inline-block;
      font-size: 16px;
      font-weight: 700;
      line-height: 22.4px;
      color: #2c364e;
    }
  }
  .files-box {
    height: 100%;
    .files-list-box {
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0 !important;
      }
    }
    .file-name-box {
      width: 100%;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
    }
    .file-info {
      display: flex;
      align-items: center;
      overflow: hidden;
    }
    .file-type {
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      margin-left: 6px;
      color: #2c364e;
    }
    .file-name {
      font-weight: 400 !important;
      color: #737e99 !important;
    }
  }
  :deep(.el-scrollbar__wrap) {
    height: calc(100% - 48px);
  }
  :deep(.el-checkbox) {
    height: 38px !important;
  }
}
.preprint-list {
  &.panelShow {
    border-color: #EFF1F7;
  }
  border-left: 1px solid transparent;
  margin-left: 16px;
  padding-left: 16px;
  flex: 0 0 460px;
  &.zh-cn {
    flex-basis: 380px;
  }
}
.pr20 {
  padding-right: 20px;
}
</style>
